import {KeyboardKeys} from "./utils/consts";

interface CollapseOptionsInterface {
  containerSelector?: string,
  buttonSelector?: string,
  contentSelector?: string,
  showClass?: string,
  isOpenIndex?: number
}

export const collapse = ({
  containerSelector = `.js-collapse`,
  buttonSelector = `.js-collapse-btn`,
  contentSelector = `.js-collapse-block`,
  showClass = `show`,
  isOpenIndex,
}: CollapseOptionsInterface) => {
  const collapseContainerElements = document.querySelectorAll(containerSelector);

  const hideContent = (content) => {
    content.style.maxHeight = `0`;
    content.style.visibility = ``;
  };

  const showContent = (content) => {
    content.style.maxHeight = `${content.scrollHeight}px`;
    content.style.visibility = `visible`;
  };

  const onInputKeyDown = (evt) => {
    if (evt.code === KeyboardKeys.SPACE || evt.code === KeyboardKeys.ENTER) {
      evt.preventDefault();

      let target = evt.target;
      let self = evt.currentTarget;

      let control = self.querySelector(buttonSelector);

      if (target === control || target.parentNode === control) {
        let content = self.querySelector(contentSelector);

        self.classList.toggle(<string>showClass);

        if (self.classList.contains(<string>showClass)) {
          showContent(content);
        } else {
          hideContent(content);
        }
      }
    }
  };

  if (collapseContainerElements.length) {
    collapseContainerElements.forEach((parent) => {
      parent.addEventListener(`click`, (evt) => {
        const target = (evt.target as HTMLElement);
        const self = (evt.currentTarget as HTMLElement);

        const control = self.querySelector(buttonSelector);

        if (target === control || target.parentNode === control) {
          const content = self.querySelector(contentSelector);

          self.classList.toggle(showClass);

          if (self.classList.contains(showClass)) {
            showContent(content);
          } else {
            hideContent(content);
          }
        }
      });

      parent.addEventListener(`keydown`, onInputKeyDown);
    });

    if (typeof isOpenIndex === `number`) {
      collapseContainerElements[isOpenIndex].classList.add(showClass);
      const content = collapseContainerElements[isOpenIndex].querySelector(contentSelector);

      if (collapseContainerElements[isOpenIndex].classList.contains(showClass)) {
        showContent(content);
      } else {
        hideContent(content);
      }
    }
  }
};
